var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRolesManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 18C31.3995 18 33.75 20.3505 33.75 23.25C33.75 26.1495 31.3995 28.5 28.5 28.5C28.149 28.5 27.8063 28.4646 27.4746 28.3989L24.0645 31.8105C23.7832 32.0918 23.4017 32.25 23.0039 32.25H21.375C20.5466 32.25 19.875 31.5785 19.875 30.75V29.1212C19.875 28.7234 20.0333 28.3418 20.3145 28.0605L23.5048 24.8686C23.3397 24.3588 23.25 23.8149 23.25 23.25C23.25 20.3505 25.6005 18 28.5 18ZM28.875 21C28.0465 21 27.375 21.6716 27.375 22.5C27.375 23.3285 28.0465 24 28.875 24C29.7035 24 30.375 23.3285 30.375 22.5C30.375 21.6716 29.7035 21 28.875 21Z",
    fill: "#171717",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.104 18.1641C13.7146 19.4685 15.7661 20.25 18 20.25C19.4825 20.25 20.8833 19.9035 22.1294 19.2906C21.4137 20.4397 21 21.7965 21 23.25C21 23.5504 21.0166 23.8473 21.0513 24.1392L18.2843 26.9092C17.8624 27.331 17.625 27.9034 17.625 28.5V31.5H9.89355C7.74336 31.4997 6.00036 29.7567 6 27.6064C6 23.4031 8.5059 19.7872 12.104 18.1641Z",
    fill: "#171717",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.75C21.9351 3.75 25.125 6.93998 25.125 10.875C25.125 14.81 21.9351 18 18 18C14.065 18 10.875 14.81 10.875 10.875C10.875 6.93998 14.065 3.75 18 3.75Z",
    fill: "#171717",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesManagement);
export default __webpack_public_path__ + "static/media/roles-management.dd97734e7604239264b29a1e8ebde699.svg";
export { ForwardRef as ReactComponent };